// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.worskpaceSettings_rcZCn {
  display: flex;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;

  .leftWorkspaceSetting_BREJZ {
    width: 30%;
    max-width: 150px;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    box-sizing: border-box;

    ul {
        gap: 10px;
        display: inline-grid;
        list-style: none;
        margin: 0;
        padding: 0;
        @media (width<=768px) {
          width: 100%;
          display: flex;
          flex-direction: row;
          overflow: scroll;
        }
        li {
          margin: 0;
          padding: 0;
          cursor: pointer;
          display: flex;
          padding: 6px 8px;
          gap: 10px;
          align-items: center;
          gap: 10px;
          min-width: 160px;
          box-sizing: border-box;
        }

        .disabledOption_pefxw {
          cursor: not-allowed;
          opacity: 0.6;
        }

        .getPlusOption_TAOo9{
          background-color: rgb(234, 251, 248);
        }
      }

      .selected_g4L85 {
        border-radius: 6px;
        background: var(--ececf1-background);
      }
  }
  .rightWorkspaceSetting_hGQdz {
    width: 70%;
    height: 100%;
    border-radius: 8px;
    border: 1px solid var(--ececf1-border);
    background: #fff;
    padding: 8px 20px 20px 20px;
    box-sizing: border-box;
    margin-right: 20px;
    box-sizing: border-box;
    max-height: 70vh;
    overflow-y: scroll;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewWorkspace/NewWorkspace.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;;EAEtB;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,sBAAsB;;IAEtB;QACI,SAAS;QACT,oBAAoB;QACpB,gBAAgB;QAChB,SAAS;QACT,UAAU;QACV;UACE,WAAW;UACX,aAAa;UACb,mBAAmB;UACnB,gBAAgB;QAClB;QACA;UACE,SAAS;UACT,UAAU;UACV,eAAe;UACf,aAAa;UACb,gBAAgB;UAChB,SAAS;UACT,mBAAmB;UACnB,SAAS;UACT,gBAAgB;UAChB,sBAAsB;QACxB;;QAEA;UACE,mBAAmB;UACnB,YAAY;QACd;;QAEA;UACE,oCAAoC;QACtC;MACF;;MAEA;QACE,kBAAkB;QAClB,oCAAoC;MACtC;EACJ;EACA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".worskpaceSettings {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  .leftWorkspaceSetting {\n    width: 30%;\n    max-width: 150px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    margin: 0 10px;\n    box-sizing: border-box;\n\n    ul {\n        gap: 10px;\n        display: inline-grid;\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        @media (width<=768px) {\n          width: 100%;\n          display: flex;\n          flex-direction: row;\n          overflow: scroll;\n        }\n        li {\n          margin: 0;\n          padding: 0;\n          cursor: pointer;\n          display: flex;\n          padding: 6px 8px;\n          gap: 10px;\n          align-items: center;\n          gap: 10px;\n          min-width: 160px;\n          box-sizing: border-box;\n        }\n\n        .disabledOption {\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n\n        .getPlusOption{\n          background-color: rgb(234, 251, 248);\n        }\n      }\n\n      .selected {\n        border-radius: 6px;\n        background: var(--ececf1-background);\n      }\n  }\n  .rightWorkspaceSetting {\n    width: 70%;\n    height: 100%;\n    border-radius: 8px;\n    border: 1px solid var(--ececf1-border);\n    background: #fff;\n    padding: 8px 20px 20px 20px;\n    box-sizing: border-box;\n    margin-right: 20px;\n    box-sizing: border-box;\n    max-height: 70vh;\n    overflow-y: scroll;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"worskpaceSettings": `worskpaceSettings_rcZCn`,
	"leftWorkspaceSetting": `leftWorkspaceSetting_BREJZ`,
	"disabledOption": `disabledOption_pefxw`,
	"getPlusOption": `getPlusOption_TAOo9`,
	"selected": `selected_g4L85`,
	"rightWorkspaceSetting": `rightWorkspaceSetting_hGQdz`
};
export default ___CSS_LOADER_EXPORT___;
